import { LAYER_COUNT, createRandomCleanEncoding } from "bitframes";
import { writable } from "svelte/store";

export function randomWithLocks(oldEncoding, opts = {}) {
  const { system = 0x00, lockedLayers = [false, false, false, false, false] } =
    opts;

  const newEncoding = createRandomCleanEncoding(undefined, { system });
  applyRandomEdit(oldEncoding, newEncoding, lockedLayers);
  return newEncoding;
}

export function applyRandomEdit(
  oldEncoding,
  newEncoding,
  lockedLayers = [false, false, false, false, false]
) {
  if (
    oldEncoding &&
    lockedLayers &&
    lockedLayers.length === LAYER_COUNT &&
    !lockedLayers.every((f) => !f)
  ) {
    const BYTES_PER_LAYER = 6;
    for (let i = 0; i < LAYER_COUNT; i++) {
      const offset = 2 + i * BYTES_PER_LAYER;
      const isLocked = lockedLayers[i];
      for (let c = 0; c < BYTES_PER_LAYER; c++) {
        if (isLocked) {
          newEncoding[offset + c] = oldEncoding[offset + c];
        }
      }
    }
  }
}
